import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useStatus } from '../../Contexts/Context_Status_Global';

export default function Panel_Map_Left() {
    const UI = useContext(Context_UI);
    const { Map_Composition, Room_Highlight, Building_Switch, Floor_Switch, Information_Display, Map_Information } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();

    const handleTabbing = () => {
        if (Panel_Right_State == "Collapsed") {
            Panel_Toggle("Right");
        }
    }

    return (
        <>
            {/* <h1 className='General_Title'>
                Directory
            </h1> */}
            <div className='Map_Composition_List'>
                {Map_Composition.map((Building, Building_Index) => (
                    <>
                        <div className='Map_Composition_List_Item' Level="1" key={Building._id} onClick={() => {
                            Building_Switch(Building_Index);
                            Information_Display("Building", Building._id);
                            handleTabbing();
                        }} State={Map_Information?._id == Building._id ? "Active" : "Inactive"}>
                            <h3 className='General_Title'>
                                {Building.Name}
                            </h3>
                            <p className='General_Paragraph'>
                                {/* {Building._id} */}
                            </p>
                        </div>
                        {Building.Floors.map((Floor, Floor_Index) => (
                            <>
                                <div className='Map_Composition_List_Item' Level="2" key={Floor._id} onClick={() => {
                                    Floor_Switch(Building_Index, Floor_Index);
                                    Information_Display("Floor", Floor._id);
                                    handleTabbing();
                                }} State={Map_Information?._id == Floor._id ? "Active" : "Inactive"}>
                                    <span></span>
                                    <p className='General_Paragraph'>
                                        {Floor.Name}
                                    </p>
                                    <p className='General_Paragraph'>
                                        {/* {Floor._id} */}
                                    </p>
                                </div>
                                {Floor.Rooms.sort((a, b) => a.Location.Code - b.Location.Code).map(Room => (
                                    <>
                                        <div className='Map_Composition_List_Item' Level="3" key={Room._id} onClick={() => {
                                            Room_Highlight(Room._id, 4, 400, "Directory");
                                            Information_Display("Room", Room._id);
                                            handleTabbing();
                                        }} State={Map_Information?._id == Room._id ? "Active" : "Inactive"}>
                                            <span></span>
                                            <p className='General_Paragraph'>
                                                {Room.Name}
                                            </p>
                                            <p className='General_Paragraph'>
                                                {/* {Floor._id} */}
                                            </p>
                                        </div>
                                    </>
                                ))}
                            </>
                        ))}
                    </>
                ))}
            </div>
        </>
    );
}
